import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router, NavigationEnd, RouterEvent} from "@angular/router";
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import {UtilsService} from "../../services/utils.service";
import {WishListService} from "../../services/wish-list.service";
import {AttractionsService} from "../../services/attractions.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  navigationClass = '';
  wishCount = 0;
  wishListObj = null;

  constructor(
    private router: Router,
    private utilsService: UtilsService,
    private wishService: WishListService,
    private attractionsService: AttractionsService
  ) {
    this.wishListObj = this.wishService.list();
    this.wishCount = this.wishCount = this.wishListObj && this.getWishCount(this.wishListObj) || 0;

    //noinspection TypeScriptUnresolvedFunction
    router.events.filter(e => e instanceof RouterEvent).subscribe(e => {
      if(e instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        if(this.utilsService.getMenuState() === true){
          this.utilsService.toggleMenu();
        }
        if(e.url !== '/'){
          this.navigationClass = '';
        }else{
          this.navigationClass = 'navigation--sans-title';
        }
      }
    });

    utilsService.wishEvents$.forEach(event => {
      if(event === 'update'){
        this.wishListObj = this.wishService.list();
        this.wishCount = this.wishListObj && this.getWishCount(this.wishListObj) || 0;
      }
    });
  }

  getWishCount = wishListObj => {
    let count = 0;
    if(!wishListObj.items) return count;
    if(wishListObj.items['attractions']){
      count += wishListObj.items['attractions'].length;
    }
    if(wishListObj.items['guides']){
      count += wishListObj.items['guides'].length;
    }
    return count;
  };

  toggleMenu = ()=>{
    this.utilsService.toggleMenu();
  };
  ngOnInit() {

  }

  wishList = [];

  wishLoading = false;
  getWishes(){
    let that = this;
    that.wishList = [];
    that.wishLoading = true;
    if(that.wishCount === 0){
      return 0;
    }

    /*that.utilsService.getVideo({path: '41b3d635-b5d9-47a4-8479-e50197257647'}).subscribe(res => {
      console.log(res);
    });*/

    that.wishService.getAll().subscribe(res => {
      that.wishLoading = false;
      that.wishList = res['data'];
    });
  }

  getLocationName(wish){
    if(wish.type === 'guides'){
      return 'guides';
    }
    if(wish.type === 'attractions'){
      return wish.location.slug;
    }
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/layouts/header/header.component.ts